import React, { useState } from "react";

import { View } from "react-native";
import { Modal, Button, TextArea } from "components";

import { colors, sizes, strings } from "assets/constants";

import css from "styles";

export default function ChangeFactorMainStatus(props: {
  visible?: boolean;
  hide?: () => void;
  onAccept: (desc: string) => void;
  onReject: (desc: string) => void;
}) {
  const { onAccept, onReject, visible, hide } = props;

  const [desc, setDesc] = useState("");

  return (
    <Modal close={hide} visible={visible}>
      <View
        style={{
          padding: sizes.space,
          backgroundColor: colors.white,
          borderTopLeftRadius: sizes.radius.lg,
          borderTopRightRadius: sizes.radius.lg,
        }}
      >
        <TextArea
          value={desc}
          onChangeText={setDesc}
          icon={{ name: "align-right" }}
          placeholder="توضیحات مربوط به تایید یا رد سفارش را وارد کنید"
        />

        <View style={{ ...css.rRowCenterAlign, ...css.justifySpaceBetween }}>
          <Button
            onPress={() => onReject(desc)}
            width={"47%"}
            title={{ value: strings.reject }}
            outline
          />
          <Button
            onPress={() => onAccept(desc)}
            width={"47%"}
            title={{ value: strings.accept }}
          />
        </View>
      </View>
    </Modal>
  );
}
